import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CategoryPage from "@/pages/CategoryPage";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PaymentResult from "@/pages/PaymentResult";
import PayLink from "@/pages/PayLink";
import Contact from "@/pages/Contact";
import PageView from "@/pages/PageView";
import Landing from "@/pages/Landing";
import CustomerAccess from "@/pages/CustomerAccess";
import SetPassword from "@/pages/SetPassword";
import CustomerAccount from "@/pages/CustomerAccount";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductEdit from "@/pages/admin/AdminProductEdit";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminOrderForm from "@/pages/admin/AdminOrderForm";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminInvoiceForm from "@/pages/admin/AdminInvoiceForm";
import AdminImport from "@/pages/admin/AdminImport";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminReturns from "@/pages/admin/AdminReturns";
import AdminConfig from "@/pages/admin/AdminConfig";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminLandings from "@/pages/admin/AdminLandings";
import AdminPages from "@/pages/admin/AdminPages";
import AdminHome from "@/pages/admin/AdminHome";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminMailings from "@/pages/admin/AdminMailings";
import AdminMailingForm from "@/pages/admin/AdminMailingForm";

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <AuthProvider>
          <CartProvider>
            <Toaster position="top-center" richColors offset={80} />
            <Routes>
              {/* PUBLIC */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/tienda" element={<Shop />} />
                <Route path="/producto/:slug" element={<ProductDetail />} />
                <Route path="/categoria/:slug" element={<CategoryPage />} />
                <Route path="/carrito" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/pedido-confirmado" element={<OrderConfirmation />} />
                <Route path="/pago-ok" element={<PaymentResult ok={true} />} />
                <Route path="/pago-ko" element={<PaymentResult ok={false} />} />
                <Route path="/pagar/:orderId" element={<PayLink />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/sobre-nosotros" element={<PageView fixedSlug="sobre-nosotros" />} />
                <Route path="/envios" element={<PageView fixedSlug="envios" />} />
                <Route path="/devoluciones" element={<PageView fixedSlug="devoluciones" />} />
                <Route path="/pagina/:slug" element={<PageView />} />
                <Route path="/acceso" element={<CustomerAccess />} />
                <Route path="/activar-cuenta" element={<SetPassword />} />
                <Route path="/mi-cuenta" element={<CustomerAccount />} />
                <Route path="/:slug" element={<Landing />} />
              </Route>

              {/* ADMIN */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="productos" element={<AdminProducts />} />
                <Route path="productos/:id" element={<AdminProductEdit />} />
                <Route path="categorias" element={<AdminCategories />} />
                <Route path="pedidos/:id" element={<AdminOrderDetail />} />
                <Route path="clientes" element={<AdminCustomers />} />
                <Route path="facturas" element={<AdminInvoices />} />
                <Route path="facturas/:id/editar" element={<AdminInvoiceForm />} />
                <Route path="devoluciones" element={<AdminReturns />} />
                <Route path="mensajes" element={<AdminMessages />} />
                <Route path="importar" element={<AdminImport />} />
                <Route path="landings" element={<AdminLandings />} />
                <Route path="inicio" element={<AdminHome />} />
                <Route path="cupones" element={<AdminCoupons />} />
                <Route path="mailings" element={<AdminMailings />} />
                <Route path="mailings/nuevo" element={<AdminMailingForm />} />
                <Route path="mailings/:id/editar" element={<AdminMailingForm />} />
                <Route path="paginas" element={<AdminPages />} />
                <Route path="pedidos" element={<AdminOrders />} />
                <Route path="pedidos/nuevo" element={<AdminOrderForm />} />
                <Route path="pedidos/:id/editar" element={<AdminOrderForm />} />
                <Route path="pedidos/:id" element={<AdminOrderDetail />} />
                <Route path="usuarios" element={<AdminUsers />} />
                <Route path="configuracion" element={<AdminConfig />} />
                <Route path="logs" element={<AdminLogs />} />
              </Route>
            </Routes>
          </CartProvider>
        </AuthProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
